/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { FiChevronRight } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import ViewAllReviewCard from "../../components/common/ViewAllReviewCard";
import { fetchProviderDetails } from "../../components/commonFunctions/CommonFunctions";
import ManualReview from "../../components/modal/ManualReview";

const ViewAllReview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const providerId = location.state?.providerId;
  const providerName = location.state?.providerName;
  const { loading, allReviews } = useSelector((state) => state.provider);

  const [ManualReviewModal, setManualReviewModal] = useState(false);
  const [reviewId, setReviewId] = useState(false);
  const dispatch = useDispatch();

  const totalRatings = allReviews?.reduce((sum, item) => sum + item.rating, 0);
  const overallRating = totalRatings / allReviews?.length;

  const handleProviderReview = () => {
    fetchProviderDetails(dispatch, providerId);
  };

  useEffect(() => {
    providerId && handleProviderReview();
  }, [providerId]);

  return (
    <>
      <div className="px-4 md:px-10 mt-4">
        <nav className="flex flex-col sm:flex-row sm:items-end justify-between mb-3">
          <div className="flex items-center space-x-2">
            <a
              href="/provider"
              className="text-[#284184] text-xl hover:underline"
            >
              All Providers
            </a>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <button
              href="/provider"
              className="text-[#284184] text-xl font-[Lato-Regular] hover:underline"
              onClick={() =>
                navigate("/providerProfile", {
                  state: { provider: { id: providerId } },
                })
              }
            >
              {providerName}
            </button>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <span className="text-[#284184] text-xl font-[Lato-Regular] font-bold">
              Review {overallRating?.toFixed(1) || 0} ({allReviews?.length || 0}
              )
            </span>
          </div>
          <div className="flex mt-3 sm:mt-0 space-x-3">
            <button
              className="bg-blue-700 flex items-center gap-2 text-white px-4 py-2 rounded-md hover:bg-blue-800"
              onClick={() => setManualReviewModal(true)}
            >
              <FaPlus /> Add Review Manually
            </button>
          </div>
        </nav>
        <div className="border rounded-2xl px-4 pt-4 bg-white">
          <div className="grid gap-4 grid-cols-1">
            {loading ? (
              <div className="h-[60vh] flex items-center justify-center">
                <PropagateLoader color="#284184" loading={true} size={10} />
              </div>
            ) : allReviews?.length === 0 ? (
              <p className="text-center text-gray-500 h-[60vh] flex justify-center items-center">
                No reviews available
              </p>
            ) : (
              allReviews &&
              allReviews?.map((review, index) => (
                <ViewAllReviewCard
                  key={index}
                  reviewData={review}
                  setManualReviewModal={setManualReviewModal}
                  setReviewId={setReviewId}
                  providerId={providerId}
                />
              ))
            )}
          </div>
        </div>
      </div>
      <ManualReview
        isOpen={ManualReviewModal}
        onClose={() => setManualReviewModal(false)}
        reviewId={reviewId}
        providerId={providerId}
        handleProviderReview={handleProviderReview}
      />
    </>
  );
};

export default ViewAllReview;
